import PolicyLayout from './PolicyLayout';

function PrivacyPolicy() {
  return (
    <PolicyLayout title="Privacy Policy">
      <p>
        Effective date: April 9, 2026. Family Tree Helps respects your privacy and is committed to protecting
        personal information shared through this website. This Privacy Policy explains what information we collect,
        how we use it, how we store it, and what rights you have.
      </p>
      <h2>Scope of This Policy</h2>
      <p>
        This policy applies to data collected through website forms, page interactions, contact inquiries, and
        normal analytics tools used for website performance and security monitoring.
      </p>
      <h2>Information We Collect</h2>
      <p>
        We may collect personal information such as your name, email address, phone number (if provided), and
        message details when you contact us. We may also collect technical information including IP address, browser
        type, device type, operating system, referral source, session duration, and visited pages.
      </p>
      <h2>How We Use Information</h2>
      <p>
        We use collected information to reply to your inquiries, improve website content, maintain security, detect
        misuse, optimize user experience, and analyze aggregated usage patterns for service planning.
      </p>
      <h2>Legal Basis for Processing</h2>
      <p>
        Where required by law, we process information based on user consent, legitimate interest in operating and
        securing the website, and fulfillment of communication you request from us.
      </p>
      <h2>Cookies</h2>
      <p>
        Cookies and similar technologies may be used for analytics, session management, and preference storage. You
        can disable cookies in your browser settings; however, some website features may not function properly.
      </p>
      <h2>Data Retention</h2>
      <p>
        We retain personal information only for as long as necessary to respond to your request, maintain inquiry
        records, comply with legal obligations, and prevent abuse. Retention periods may vary depending on request
        type and regulatory requirements.
      </p>
      <h2>Data Security</h2>
      <p>
        We use commercially reasonable technical and organizational safeguards to protect information from improper
        access, alteration, disclosure, or destruction. No internet transmission or storage system is completely
        secure, so absolute security cannot be guaranteed.
      </p>
      <h2>Third-Party Services</h2>
      <p>
        We may use trusted third-party service providers for hosting, analytics, security monitoring, and website
        functionality. These providers may process limited data on our behalf under contractual or legal safeguards.
      </p>
      <h2>Children&apos;s Privacy</h2>
      <p>
        Our website is not directed to children under 13. We do not knowingly collect personal information from
        children. If such data is identified, we will remove it as reasonably possible.
      </p>
      <h2>International Users</h2>
      <p>
        If you access the website from outside your country, your information may be processed in regions where
        servers or service providers operate. By using the website, you understand and accept this transfer.
      </p>
      <h2>Your Rights</h2>
      <p>
        Depending on applicable law, you may request access, correction, deletion, restriction, or portability of
        your personal information, and may object to specific processing activities. You may also withdraw consent
        where consent is the legal basis.
      </p>
      <h2>Do Not Track</h2>
      <p>
        Some browsers transmit &quot;Do Not Track&quot; signals. Due to lack of uniform standards, our website may
        not respond to all such signals consistently.
      </p>
      <h2>Contact for Privacy Requests</h2>
      <p>
        For privacy-related requests, contact us through the website contact section with enough details to verify
        your request. We may require additional information to confirm identity before processing.
      </p>
      <h2>Policy Updates</h2>
      <p>
        We may update this policy periodically to reflect legal, technical, or operational changes. Revised versions
        become effective when published on this page with an updated effective date.
      </p>
    </PolicyLayout>
  );
}

export default PrivacyPolicy;

